export enum UploadFileError {
  FILE_SIZE_LARGER_THAN_TARGET_MAX_SIZE = "FILE_SIZE_LARGER_THAN_TARGET_MAX_SIZE",
}
